
import { Link, useNavigate } from "react-router-dom";


export default function VehicleIncidentTable() {
    const navigate = useNavigate();

    const handleNavigate = (vehiclecode) => {
        navigate(`/${vehiclecode}`);


    };
    const data = [
        { id: 1, vehiclecode: "Test Vehicle", driver: "Super Fast", Location: "Pune", description: "Trip", expense: "$2000", date: "Mon Jul 8 2023" },
        { id: 2, vehiclecode: "Test Vehicle", driver: "Super Fast", Location: "Pune", description: "Trip", expense: "$2344", date: "Mon Jul 8 2023" },
        { id: 3, vehiclecode: "Test Vehicle", driver: "Super Fast", Location: "Pune", description: "Trip", expense: "$1233", date: "Mon Jul 8 2023" },
        { id: 4, vehiclecode: "MH04KL0921", driver: "Super Fast", Location: "Nashik", description: "Trip", expense: "$2000", date: "Mon Jul 8 2023" },
        { id: 5, vehiclecode: "MH05MH5932", driver: "Super Fast", Location: "Jalna", description: "Drop", expense: "$2000", date: "Mon Jul 8 2023" },
        { id: 6, vehiclecode: "MH06MJ4321", driver: "Super Fast", Location: "Pune", description: "Drop", expense: "$2000", date: "Mon Jul 8 2023" },
        { id: 7, vehiclecode: "Test Vehicle", driver: "Super Fast", Location: "Delhi", description: "Drop", expense: "$2000", date: "Mon Jul 8 2023" },
        { id: 8, vehiclecode: "MH08KK4909", driver: "Super Fast", Location: "Goa", description: "Trip", expense: "$2000", date: "Tue Jul 9 2023" },
        { id: 9, vehiclecode: "MH11KL0008", driver: "Super Fast", Location: "Mumbai", description: "Trip", expense: "$2000", date: "Tue Jul 9 2023" },
        { id: 10, vehiclecode: "MH20UI3424", driver: "Super Fast", Location: "Mumbai", description: "trip", expense: "$2000", date: "Mon Jul 8 2023" },
        { id: 11, vehiclecode: "Test Vehicle", driver: "Test Driver", Location: "Mumbai", description: "Trip", expense: "$2000", date: "Tue Jul 9 2023" },
        { id: 12, vehiclecode: "MH23MK8245", driver: "Test Driver", Location: "Mumbai", description: "Trip", expense: "$2000", date: "Mon Jul 8 2023" },
        { id: 13, vehiclecode: "MH24NF5321", driver: "Jake Sprrow", Location: "Mumbai", description: "Drop", expense: "$2000", date: "Tue Jul 9 2023" },
        { id: 14, vehiclecode: "MH22PQ4441", driver: "Tom", Location: "Assam", description: "Trip", expense: "$2000", date: "Mon Jul 8 2023" },
        { id: 15, vehiclecode: "New Vehicle", driver: "John wick", Location: "North", description: "Drop", expense: "$2000", date: "Mon Jul 8 2023" },
        { id: 30, vehiclecode: "MH11FG9090", driver: "John wick", Location: "South", description: "Trip", expense: "$2000", date: "Tue Jul 9 2023" },
        { id: 17, vehiclecode: "MH20UI1221", driver: "Tom", Location: "West", description: "Trip", expense: "$2000", date: "Mon Jul 8 2023" },
        { id: 18, vehiclecode: "New Vehicle", driver: "John", Location: "East", description: "Trip", expense: "$2000", date: "Tue Jul 9 2023" },
        { id: 19, vehiclecode: "MH20SQ0987", driver: "Harry", Location: "North", description: "drop", expense: "$2000", date: "Mon Jul 8 2023" },
        { id: 20, vehiclecode: "New Vehicle", driver: "Jerrey", Location: "Mumbai", description: "Trip", expense: "$2000", date: "Mon Jul 8 2023" },


    ];


    return (
        <div className="vehicle-incident-container my-4">

            <div className="special-header panel-white-all bg-white d-flex justify-content-between align-items-center">
                <h4 className="mb-0 page-title">Vehicle Incident</h4>
                <div className="d-flex align-items-center gap-2">
                    <Link to="/accountant/createvehicleincident" type="button" className="btn custom-btn">Create Vehicle Incident</Link>

                    <div className="dropdown">
                        <button id="btnGroupDropExport" type="button" className="btn custom-btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                            Export
                        </button>
                        <ul className="dropdown-menu" aria-labelledby="btnGroupDropExport">
                            <li><a className="dropdown-item" href="#">Save as PDF</a></li>
                            <li><a className="dropdown-item" href="#">Save as PNG</a></li>
                            <li><a className="dropdown-item" href="#">Save as CSV</a></li>
                            <li><a className="dropdown-item" href="#">Save as TXT</a></li>
                            <li><a className="dropdown-item" href="#">Save as XML</a></li>
                            <li><a className="dropdown-item" href="#">Save as SQL</a></li>
                        </ul>
                    </div>
                </div>
            </div>

           <div className="table-top-filters d-flex flex-wrap gap-3">
                                <select className="form-select form-control-sm dropdrown-iteam"  style={{ maxWidth: "200px" }} >
                                    <option className="vehicle-dropdown">All</option>
                                    <option className="vehicle-dropdown">MH20EE3948</option>
                                    <option className="vehicle-dropdown">Test Vehicle</option>
                                </select>
                         
                                <input type="text" className="form-control form-control-sm" placeholder="Location"  style={{ maxWidth: "200px" }}/>
                   
                            <button type="button" class="btn custom-btn">Clear</button>


           </div>
            <div className="card-body">

                <div className="table-responsive">
                    <table className="custom-table">
                        <thead>
                           

                            <tr>
                                <th style={{textAlign:'center'}}>Sr No</th>
                                <th style={{textAlign:'center'}}>Vehicle Number/Name</th>
                                <th style={{textAlign:'center'}}>Driver</th>
                                <th style={{textAlign:'center'}}>Location</th>
                                <th style={{textAlign:'center'}}>Description</th>
                                <th style={{textAlign:'center'}}>Expense</th>
                                <th style={{textAlign:'center'}}>Date</th>
                                <th >Action</th>
                            </tr>

                        </thead>
                        <tbody>
                            {data.map((row) => (
                                <tr key={row.id}>
                                    <td style={{textAlign:'center'}}>{row.id}</td>
                                    <td style={{textAlign:'center'}}>{row.vehiclecode}</td>
                                    <td style={{textAlign:'center'}}>{row.driver}</td>
                                    <td style={{textAlign:'center'}}>{row.Location}</td>
                                    <td style={{textAlign:'center'}}>{row.description}</td>
                                    <td style={{textAlign:'center'}}>{row.expense}</td>
                                    <td style={{textAlign:'center'}}>{row.date}</td>
                                    <td style={{textAlign:'center'}} >
                                        <div className="btn-group">
                                            <button
                                                type="button"
                                                className="btn  btn-sm"
                                                onClick={() => handleNavigate(row.vehiclecode)}
                                                title="View">
                                                <i class="bi bi-eye" style={{marginLeft:'-5px'}}></i>
                                            </button>
                                            <Link to="/accountant/updatevehicleincident"
                                                type="button"
                                                className="btn  btn-sm"
                                                title="View">
                                                <i className="bi bi-pencil-square" style={{marginLeft:'-5px'}} ></i>
                                            </Link>
                                            <button
                                                type="button"
                                                className="btn  btn-sm"
                                                onClick={() => handleNavigate(row.vehiclecode)}
                                                title="View">
                                                <i className="bi bi-trash3" style={{marginLeft:'-5px'}}></i>
                                            </button>
                                        </div>

                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>




    );
}
